import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CmsConfig, provideConfig } from 'haba-core';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    provideConfig(<CmsConfig>{
      featureModules: {
        Parcellab: {
          module: () => import('./parcellab.module').then((m) => m.ParcellabModule),
          cmsComponents: ['ParcellabComponent'],
        },
      },
    }),
    provideConfig(<CmsConfig>{
      routing: {
        routes: {
          sendungsverfolgung: { paths: ['sendungsverfolgung'] },
        },
      },
    }),
  ],
})
export class ParcellabFeatureModule {}
